// Import external
import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor() {
    }

    handleError(error: any) {
        // only log in sentry in production environments
        Sentry.captureException(error.originalError || error);

        // always log the error in the browser
        // eslint-disable-next-line no-console
        console.error(error);

        throw error;
    }
}
